<template>
    
</template>

<script>
    export default {
        name: "empWagesDetailColumnsList"
    }
</script>

<style scoped>

</style>
